import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var ReplySVG = function ReplySVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M26.561,14.85A12.249,12.249,0,0,0,18,12H5.414l6.293-6.293a1,1,0,1,0-1.414-1.414l-8,8a1,1,0,0,0,0,1.414l8,8a1,1,0,0,0,1.414-1.414L5.414,14l12.669,0c.046,0,4.26-.313,7.139,2.339C27.065,18.035,28,20.614,28,24v3a1,1,0,0,0,2,0V24C30,20.022,28.843,16.944,26.561,14.85Z"
  }));
};
ReplySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ReplySVG);